import { Component, Input } from '@angular/core';
import { IsActiveMatchOptions, Params, Router } from '@angular/router';

export interface SideNavLinkOption {
  enabled: boolean;
  type: 'link';
  label: string;
  icon: string;
  iconNamespace?: string;
  onSelect: () => void;
  routerLinkActiveOptions?:
    | {
        exact: boolean;
      }
    | IsActiveMatchOptions;
  routes: {
    path: string;
    queryParams?: Params;
  }[];
  notificationCount?: number;
}

@Component({
  selector: 'app-sidenav-link-option',
  templateUrl: './sidenav-link-option.component.html',
  styleUrls: ['./sidenav-link-option.component.scss'],
  standalone: false,
})
export class SidenavLinkOptionComponent {
  @Input() option: SideNavLinkOption;
  @Input() collapsed: boolean;

  constructor(public router: Router) {}
}
